<template>
    <Splide :options="mainOptions" 
    @splide:moved="handleMainSlideMoved"
    :has-track="false" ref="main">
                <SplideTrack>
                    <SplideSlide v-for="item in images.slice(0, 8)">
                        <div class="image__wrapper">
                                <img :src="src(item)" alt="" loading="lazy">
                        </div>
                    </SplideSlide>
                </SplideTrack>
                <ul class="custom-pagination">
                    <li v-for="(slide,index) in images.slice(0, 8)" :key="index" :class="{ active: activeSlide === index }"
                        @click="goToSlide(index)">
                    </li>
                </ul>
            </Splide>
    </template>
    
    <script>
    import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
    import '@splidejs/vue-splide/css';
    import '@splidejs/vue-splide/css/skyblue';
    import '@splidejs/vue-splide/css/sea-green';
    import '@splidejs/vue-splide/css/core';
        export default {
            components: { Splide, SplideSlide, SplideTrack },
            props: {
                images: [Array,Object],
            },
            data() {
                return {
                    activeSlide: 0,
                    mainOptions: {
                        padding: '0px',
                        focus: 'center',
                        gap: 24,
                        padding: 0,
                        autoHeight: true,
                        arrows: false,
                        pagination: false,
                        breakpoints: {
                            1320: {
                                perPage: 1,
                            },
                            1024: {
                                perPage: 1,
                            },
                            768: {
                                perPage: 1,
                            },
                        }
                    },
                }
            },
            methods: {
                src(item) {
                    // Внешние картинки (UGM) приходят полным URL
                    return /^https?:\/\//.test(item) ? item : `${this.$store.state.base_directory}${item.replace(/^public\//, '')}`;
                },
                handleMainSlideMoved() {
                    this.activeSlide = this.$refs.main.splide.index;
                },
                goToSlide(index) {
                    this.$refs.main.go(index);
                },
            },
        }
    </script>
    
    <style scoped>
    .splide{
        padding: 0;
        padding-bottom: 20px;
        z-index: 2;
    }
    .image__wrapper{
        position: relative;
        padding-top: 82%;
    }
    .image__wrapper img {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%; /* Высота зависит от экрана */
        object-fit: cover;
    }
    .custom-pagination {
        left: 50%;
        transform: translateX(-50%);
        position: absolute;
        bottom: 0px;
        display: flex;
        gap: 4px;
        border-radius: 12px;
        align-items: center;
      }
    .custom-pagination::before {
      content: '';
      position: absolute;
      top: -1.5px;
      left: -1.5px;
      width: calc(100% + 3px);
      height: calc(100% + 3px);
      border-radius: inherit;
      background-color: rgba(255, 255, 255, 0.16);
      filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.06)) drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.04));
      backdrop-filter: blur(1px);
      z-index: -1; /* Помещаем псевдоэлемент позади основного элемента */
    }
      .custom-pagination li {
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: rgb(255, 255, 255);
        transition: all 0.1s;
        cursor: pointer;
      }
      
      .custom-pagination li.active {
        background: rgb(255, 183, 16);
        width: 4px;
        height: 4px;
      }
    </style>